import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import CustomerFeedbackNavbar from "../components/CustomerFeedbackNavbar";
import CustomerSupportTable from "../components/CustomerSupportTable";
const CustomerSupport = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };
  return (
    <div>
      <Sidebar debarStateChange={handleSidebarStateChange} />
      <CustomerFeedbackNavbar />
      <CustomerSupportTable />
    </div>
  );
};

export default CustomerSupport;
